import LocalStorage from '@/services/store/LocalStorage'

export default new LocalStorage()
